import React from 'react'
import { AppBar, Toolbar, Typography, Button, withStyles, Container, Hidden } from '@material-ui/core'
import { Link } from 'react-router-dom';
import logo from '../../spe_logo.png'

const styles = (theme => ({
  root: {
    flexGrow: 1,
    marginBottom: theme.spacing(4)
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
    '& *': {
      textDecoration: 'none',
      color: 'inherit'
    }
  },
  logo: {
    textAlign: 'center',
  }
}));

class Navbar extends React.Component {
  getElevation = () => {
    if (window.innerWidth > 960) {
      return 1
    }
    return 5
  }

  renderNavbar = (classes) => (
    <div>
      <AppBar position="static" color="primary" elevation={this.getElevation()} className={classes.root} >
        <Toolbar className="no-padding">
          <Hidden xsDown>
            <Typography variant="h6" className={classes.title}>
              <Link to="/" >
                SPE BUE
                  </Link>
            </Typography>
          </Hidden>
          <Link component={Button} to="/" color="inherit">Home</Link>
          <Link component={Button} to="/articles" color="inherit">Articles</Link>
          <Link component={Button} to="/about" color="inherit">About us</Link>
          <Link component={Button} to="/staff" color="inherit">Staff</Link>
          <Button component={Button} href="https://www.dailyfx.com/crude-oil" color="inherit">Stocks</Button>
        </Toolbar>
      </AppBar>
    </div>
  )

  render() {
    const classes = this.props.classes;
    return (
      <div>
        <div className="logo">
          <img src={logo} alt="SPE BUE" />
        </div>
        <Hidden smDown>
          <Container>
            {this.renderNavbar(classes)}
          </Container>
        </Hidden>
        <Hidden mdUp>
          {this.renderNavbar(classes)}
        </Hidden>
      </div>
    )
  }
}

export default withStyles(styles)(Navbar);